import React, { Component } from 'react';
import { spring, StaggeredMotion } from 'react-motion';

import { DataHandler, StorageHandler, ToolboxCard } from 'C4';
import { storageKeys } from 'settings';

import APIHandler from 'config/APIHandler';

export default class Toolbox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toolbox: [],
    };
  }

  componentWillMount() {
    StorageHandler.load(storageKeys.user).then((user) => {
      APIHandler.getLocation().then((location) => {
      DataHandler.matchAppId().then((appId) => {
        APIHandler.getToolbox(appId)
          .then((res) => {
            const startingValues = [];
            Object.keys(res).map(() => {
              const newObj = {};
              newObj.data = 0;
              newObj.pos = 20;
              return startingValues.push(newObj);
            });
            const toolboxItems = (
              <StaggeredMotion
                defaultStyles={startingValues}
                styles={prevInterpolatedStyles => prevInterpolatedStyles.map((_, i) => (i === 0
                  ? { data: spring(1, { stiffness: 320, damping: 28 }), pos: spring(0, { stiffness: 320, damping: 28 }) }
                  : { data: spring(prevInterpolatedStyles[i - 1].data, { stiffness: 320, damping: 28 }), pos: spring(prevInterpolatedStyles[i - 1].pos, { stiffness: 320, damping: 28 }) }))}
              >
                {styles => (
                  <React.Fragment>
                    {res.map((tool, id) => {
                        const {
                          type, title, subtitle, url, itemID, image,
                        } = tool;

                        if (tool.type) {
                          const key = id;
                        
                          if (location && (location.countryCode === 'NZ' || location.countryCode === 'AU') && title === 'AUS/NZ Sell Sheets and Sales Team Contacts') {
                            return (
                              <div key={key} className="ToolboxCard__Animated" style={{ opacity: `${styles[key].data}`, transform: `translateY(${styles[key].pos}%)` }}>
                                <ToolboxCard
                                  appId={appId}
                                  image={image}
                                  key={key}
                                  index={key}
                                  subtitle={subtitle}
                                  title={title}
                                  type={type}
                                  url={url}
                                  itemID={itemID}
                                  user={user}
                                />
                              </div>
                            );
                          }
           
                          if (location && (location.countryCode === 'AU' || location.countryCode === 'NZ') && title === 'AU/NZ Social Media Toolkits') {
                            return (
                              <div key={key} className="ToolboxCard__Animated" style={{ opacity: `${styles[key].data}`, transform: `translateY(${styles[key].pos}%)` }}>
                                <ToolboxCard
                                  appId={appId}
                                  image={image}
                                  key={key}
                                  index={key}
                                  subtitle={subtitle}
                                  title={title}
                                  type={type}
                                  url={url}
                                  itemID={itemID}
                                  user={user}
                                />
                              </div>
                            );
                          }

                          if (location && (location.countryCode === 'AU' || location.countryCode === 'NZ') && title === 'AU/NZ Brochures') {
                            return (
                              <div key={key} className="ToolboxCard__Animated" style={{ opacity: `${styles[key].data}`, transform: `translateY(${styles[key].pos}%)` }}>
                                <ToolboxCard
                                  appId={appId}
                                  image={image}
                                  key={key}
                                  index={key}
                                  subtitle={subtitle}
                                  title={title}
                                  type={type}
                                  url={url}
                                  itemID={itemID}
                                  user={user}
                                />
                              </div>
                            );
                          }

                          if (location && (location.countryCode === 'AU' || location.countryCode === 'NZ') && title === 'AU/NZ Sell Sheets, Sales Team Contacts, and Incentives') {
                            return (
                              <div key={key} className="ToolboxCard__Animated" style={{ opacity: `${styles[key].data}`, transform: `translateY(${styles[key].pos}%)` }}>
                                <ToolboxCard
                                  appId={appId}
                                  image={image}
                                  key={key}
                                  index={key}
                                  subtitle={subtitle}
                                  title={title}
                                  type={type}
                                  url={url}
                                  itemID={itemID}
                                  user={user}
                                />
                              </div>
                            );
                          }

                          if (location && (location.countryCode !== 'AU' || location.countryCode !== 'NZ') && title === 'AU/NZ Social Media Toolkits') {
                            return null;
                          }

                          if (location && (location.countryCode !== 'AU' || location.countryCode !== 'NZ') && title === 'AU/NZ Sell Sheets, Sales Team Contacts, and Incentives') {
                            return null;
                          }

                          if (location && (location.countryCode !== 'AU' || location.countryCode !== 'NZ') && title === 'AU/NZ Brochures') {
                            return null;
                          }

                          if (location && (location.countryCode === 'AU' || location.countryCode === 'NZ') && title === 'Trade Sell Sheets') {
                            return null;
                          }

                          if (location && (location.countryCode === 'AU' || location.countryCode === 'NZ') && title === 'Travel Advisor Facebook Group') {
                            return null;
                          }
            
                          if (location && (location.countryCode === 'AU' || location.countryCode === 'NZ') && title === 'Contact Us') {
                            return null;
                          }

                          if (location && (location.countryCode === 'AU' || location.countryCode === 'NZ') && title === 'Webinars & Presentations') {
                            return null;
                          }

                          if (location && (location.countryCode === 'AU' || location.countryCode === 'NZ') && title === 'Trade Portal') {
                            return null;
                          }

                          if (location && (location.countryCode === 'AU' || location.countryCode === 'NZ') && title === 'Social Media Toolkits') {
                            return null;
                          }
                          
                          return (
                            <div key={key} className="ToolboxCard__Animated" style={{ opacity: `${styles[key].data}`, transform: `translateY(${styles[key].pos}%)` }}>
                              <ToolboxCard
                                appId={appId}
                                image={image}
                                key={key}
                                index={key}
                                subtitle={subtitle}
                                title={title}
                                type={type}
                                url={url}
                                itemID={itemID}
                                user={user}
                              />
                            </div>
                          );
                        }
                        return null;
                    })}
                  </React.Fragment>
                )}
              </StaggeredMotion>);
            this.setState({ toolbox: toolboxItems });
          });
      });
      });
    });
  }

  render() {
    return (
      <div className="toolbox__Grid">
        {this.state.toolbox}
      </div>
    );
  }
}
